// import React, {
//   useCallback,
//   useEffect,
//   useState,
// } from "react";

// import {
//   useNavigate,
//   useParams,
// } from "react-router-dom";

// import {
//   FontAwesomeIcon,
// } from "@fortawesome/react-fontawesome";

// import {
//   faArrowRight,
//   faBoxOpen,
//   faClockRotateLeft,
//   faCreditCard,
//   faLocationDot,
//   faPlus,
//   faReceipt,
//   faSave,
//   faTimeline,
//   faTrash,
//   faUser,
// } from "@fortawesome/free-solid-svg-icons";

// import {
//   toast,
// } from "react-hot-toast";

// import {
//   ApiError,
// } from "../api/apiError";

// import {
//   ordersAdminApi,
// } from "../api/ordersAdminApi";

// import {
//   usersApi,
// } from "../api/usersApi";

// import {
//   productsApi,
// } from "../api/productsApi";

// import type {
//   UserAddress,
// } from "../types/users.types";

// import type {
//   AdminProduct,
// } from "../types/products.types";

// import type {
//   OrderItem,
//   OrderRecord,
//   OrderStatus,
//   OrderStatusHistoryItem,
//   OrderTimelineItem,
//   PaymentStatus,
//   ReplaceOrderItemInput,
// } from "../types/orders-admin.types";

// import "../screenstyles/AdminOrders.css";

// /* =========================================================
//  * Helpers
//  * ======================================================= */

// function formatDate(
//   value: any,
// ) {
//   if (!value) {
//     return "—";
//   }

//   let date:
//     | Date
//     | null = null;

//   if (
//     typeof value ===
//     "string"
//   ) {
//     date =
//       new Date(value);
//   } else {
//     const seconds =
//       value.seconds ??
//       value._seconds;

//     if (
//       typeof seconds ===
//       "number"
//     ) {
//       date =
//         new Date(
//           seconds *
//             1000,
//         );
//     }
//   }

//   if (
//     !date ||
//     Number.isNaN(
//       date.getTime(),
//     )
//   ) {
//     return "—";
//   }

//   return new Intl.DateTimeFormat(
//     "ar-IQ",
//     {
//       year:
//         "numeric",

//       month:
//         "long",

//       day:
//         "2-digit",

//       hour:
//         "2-digit",

//       minute:
//         "2-digit",
//     },
//   ).format(date);
// }

// function getAddressLabel(
//   address:
//     UserAddress,
// ) {
//   const parts = [
//     address.addressName,
//     address.province,
//     address.City,
//     address.address,
//     address.gate,
//   ]
//     .map(
//       value =>
//         String(
//           value ||
//             "",
//         ).trim(),
//     )
//     .filter(
//       Boolean,
//     );

//   return (
//     parts.join(" - ") ||
//     address.locationName ||
//     "عنوان"
//   );
// }

// function getCurrentAddressName(
//   order:
//     OrderRecord,
// ) {
//   if (
//     order.address &&
//     typeof order.address ===
//       "object"
//   ) {
//     const address =
//       order.address as
//         Record<
//           string,
//           unknown
//         >;

//     return String(
//       address.addressName ??
//         address.locationName ??
//         order.locationName ??
//         "عنوان الطلب",
//     );
//   }

//   return (
//     order.locationName ||
//     "عنوان الطلب"
//   );
// }

// function getCurrentAddressDetails(
//   order:
//     OrderRecord,
// ) {
//   if (
//     !order.address ||
//     typeof order.address !==
//       "object"
//   ) {
//     return (
//       order.locationName ||
//       "لا توجد تفاصيل عنوان محفوظة"
//     );
//   }

//   const address =
//     order.address as
//       Record<
//         string,
//         unknown
//       >;

//   return [
//     address.province,
//     address.City ??
//       address.city,
//     address.address,
//     address.gate,
//     address.additionalInfo,
//   ]
//     .map(
//       value =>
//         typeof value ===
//         "string"
//           ? value.trim()
//           : "",
//     )
//     .filter(Boolean)
//     .join(" - ");
// }

// function getCurrentAddressPhone(
//   order:
//     OrderRecord,
// ) {
//   if (
//     !order.address ||
//     typeof order.address !==
//       "object"
//   ) {
//     return "";
//   }

//   const address =
//     order.address as
//       Record<
//         string,
//         unknown
//       >;

//   return typeof address.phoneNumber ===
//     "string"
//     ? address.phoneNumber
//     : "";
// }

// /* =========================================================
//  * Component
//  * ======================================================= */

// const AdminOrderDetails:
// React.FC = () => {
//   const {
//     orderId,
//   } =
//     useParams<{
//       orderId:
//         string;
//     }>();

//   const navigate =
//     useNavigate();

//   /* =======================================================
//    * Order
//    * ===================================================== */

//   const [
//     order,
//     setOrder,
//   ] =
//     useState<
//       OrderRecord |
//       null
//     >(null);

//   const [
//     history,
//     setHistory,
//   ] =
//     useState<
//       OrderStatusHistoryItem[]
//     >([]);

//   const [
//     timeline,
//     setTimeline,
//   ] =
//     useState<
//       OrderTimelineItem[]
//     >([]);

//   const [
//     loading,
//     setLoading,
//   ] =
//     useState(true);

//   const [
//     saving,
//     setSaving,
//   ] =
//     useState(false);

//   /* =======================================================
//    * Status
//    * ===================================================== */

//   const [
//     status,
//     setStatus,
//   ] =
//     useState<
//       OrderStatus
//     >(
//       "pending",
//     );

//   const [
//     statusReason,
//     setStatusReason,
//   ] =
//     useState("");

//   /* =======================================================
//    * Payment
//    * ===================================================== */

//   const [
//     paymentStatus,
//     setPaymentStatus,
//   ] =
//     useState<
//       PaymentStatus
//     >(
//       "pending",
//     );

//   const [
//     paymentReason,
//     setPaymentReason,
//   ] =
//     useState("");

//   /* =======================================================
//    * Address
//    * ===================================================== */

//   const [
//     addressId,
//     setAddressId,
//   ] =
//     useState("");

//   const [
//     locationName,
//     setLocationName,
//   ] =
//     useState("");

//   const [
//     addressReason,
//     setAddressReason,
//   ] =
//     useState("");

//   const [
//     userAddresses,
//     setUserAddresses,
//   ] =
//     useState<
//       UserAddress[]
//     >([]);

//   const [
//     addressesLoading,
//     setAddressesLoading,
//   ] =
//     useState(false);

//   /* =======================================================
//    * Items / Products
//    * ===================================================== */

//   const [
//     items,
//     setItems,
//   ] =
//     useState<
//       ReplaceOrderItemInput[]
//     >([]);

//   const [
//     itemsReason,
//     setItemsReason,
//   ] =
//     useState("");

//   const [
//     products,
//     setProducts,
//   ] =
//     useState<
//       AdminProduct[]
//     >([]);

//   const [
//     productsLoading,
//     setProductsLoading,
//   ] =
//     useState(false);

//   const [
//     productSearch,
//     setProductSearch,
//   ] =
//     useState("");

//   /* =======================================================
//    * Load User Addresses
//    * ===================================================== */

//   const loadUserAddresses =
//     useCallback(
//       async (
//         userId:
//           string,
//       ) => {
//         if (!userId) {
//           setUserAddresses(
//             [],
//           );

//           return;
//         }

//         try {
//           setAddressesLoading(
//             true,
//           );

//           const result =
//             await usersApi
//               .getAddresses(
//                 userId,
//               );

//           setUserAddresses(
//             result.items ??
//               [],
//           );
//         } catch (
//           error
//         ) {
//           console.error(
//             "Failed to load user addresses:",
//             error,
//           );

//           setUserAddresses(
//             [],
//           );
//         } finally {
//           setAddressesLoading(
//             false,
//           );
//         }
//       },
//       [],
//     );

//   /* =======================================================
//    * Load Products
//    * ===================================================== */

// //   const loadProducts =
// //     useCallback(
// //       async (
// //         search = "",
// //       ) => {
// //         try {
// //           setProductsLoading(
// //             true,
// //           );

// //           const result =
// //             await productsApi
// //               .adminList({
// //                 search:
// //                   search
// //                     .trim() ||
// //                   undefined,

// //                 isActive:
// //                   true,

// //                 isDeleted:
// //                   false,

// //                 limit:
// //                   50,

// //                 sort:
// //                   "createdAt_desc",
// //               });

// //           setProducts(
// //             result.items ??
// //               [],
// //           );
// //         } catch (
// //           error
// //         ) {
// //           console.error(
// //             "Failed to load products:",
// //             error,
// //           );

// //           toast.error(
// //             "فشل تحميل المنتجات",
// //           );
// //         } finally {
// //           setProductsLoading(
// //             false,
// //           );
// //         }
// //       },
// //       [],
// //     );

// const loadProducts =
//   useCallback(
//     async (
//       search = "",
//     ) => {
//       try {
//         setProductsLoading(
//           true,
//         );

//         const result =
//           await productsApi
//             .adminList({
//               search:
//                 search
//                   .trim() ||
//                 undefined,

//               limit:
//                 50,

//               sort:
//                 "createdAt_desc",
//             });

//         const loadedProducts =
//           result.items ??
//           [];
// console.log(
//   "ADMIN PRODUCTS RESULT:",
//   loadedProducts.map(
//     product => ({
//       id:
//         product.id,

//       code:
//         product.code,

//       name:
//         product.name,

//       quantity:
//         product.quantity,

//       stockStatus:
//         product.stockStatus,

//       showStatus:
//         product.showStatus,

//       showStutas:
//         product.showStutas,

//       isActive:
//         product.isActive,

//       isDeleted:
//         product.isDeleted,
//     }),
//   ),
// );
//         setProducts(
//           loadedProducts.filter(
//             product =>
//               product.isDeleted !==
//               true,
//           ),
//         );
//       } catch (
//         error: any
//       ) {
//         console.error(
//           "Failed to load products:",
//           error,
//         );

//         setProducts(
//           [],
//         );

//         toast.error(
//           error?.message ||
//             "فشل تحميل المنتجات",
//         );
//       } finally {
//         setProductsLoading(
//           false,
//         );
//       }
//     },
//     [],
//   );
//   /* =======================================================
//    * Load Order
//    * ===================================================== */

//   const load =
//     useCallback(
//       async () => {
//         if (
//           !orderId
//         ) {
//           return;
//         }

//         try {
//           setLoading(
//             true,
//           );

//           const [
//             detailsResult,
//             historyResult,
//             timelineResult,
//           ] =
//             await Promise.all([
//               ordersAdminApi
//                 .getById(
//                   orderId,
//                 ),

//               ordersAdminApi
//                 .getStatusHistory(
//                   orderId,
//                 ),

//               ordersAdminApi
//                 .getTimeline(
//                   orderId,
//                   {
//                     limit:
//                       100,
//                   },
//                 ),
//             ]);

//           const loaded =
//             detailsResult.order;

//           setOrder(
//             loaded,
//           );

//           setStatus(
//             loaded.status,
//           );

//           setPaymentStatus(
//             loaded.paymentStatus,
//           );

//           setAddressId(
//             loaded.addressId ??
//               "",
//           );

//           setLocationName(
//             loaded.locationName ??
//               "",
//           );

//           setHistory(
//             historyResult.items ??
//               [],
//           );

//           setTimeline(
//             timelineResult.items ??
//               [],
//           );

//           setItems(
//             (
//               loaded.items ??
//               []
//             ).map(
//               (
//                 item:
//                   OrderItem,
//               ) => ({
//                 productId:
//                   item.productId,

//                 quantity:
//                   item.quantity,
//               }),
//             ),
//           );
// await loadUserAddresses(
//   loaded.userId,
// );
//         } catch (
//           error
//         ) {
//           console.error(
//             "Failed loading order:",
//             error,
//           );

//           if (
//             error instanceof
//             ApiError
//           ) {
//             toast.error(
//               error.message ||
//                 "فشل تحميل الطلب",
//             );

//             return;
//           }

//           toast.error(
//             "تعذر الاتصال بالخادم",
//           );
//         } finally {
//           setLoading(
//             false,
//           );
//         }
//       },
//      [
//   orderId,
//   loadUserAddresses,
// ],
//     );

//   useEffect(() => {
//     load();
//   }, [
//     load,
//   ]);

//   /* =======================================================
//    * Product Search
//    * ===================================================== */

//   useEffect(() => {
//   const searchValue =
//     productSearch.trim();

//   if (
//     searchValue.length <
//     2
//   ) {
//     setProducts(
//       [],
//     );

//     return;
//   }

//   const timer =
//     window.setTimeout(
//       () => {
//         loadProducts(
//           searchValue,
//         );
//       },
//       400,
//     );

//   return () =>
//     window.clearTimeout(
//       timer,
//     );
// }, [
//   productSearch,
//   loadProducts,
// ]);

//   /* =======================================================
//    * Find Product
//    * ===================================================== */

//   const getProductById =
//     (
//       productId:
//         string,
//     ) => {
//       return (
//         products.find(
//           product =>
//             product.id ===
//             productId,
//         ) ??
//         null
//       );
//     };

//   const getOrderItemByProductId =
//     (
//       productId:
//         string,
//     ) => {
//       return (
//         order?.items?.find(
//           item =>
//             item.productId ===
//             productId,
//         ) ??
//         null
//       );
//     };

//   /* =======================================================
//    * Update Status
//    * ===================================================== */

//   const updateStatus =
//     async () => {
//       if (
//         !orderId
//       ) {
//         return;
//       }

//       try {
//         setSaving(
//           true,
//         );

//         await ordersAdminApi
//           .updateStatus(
//             orderId,
//             {
//               status,

//               reason:
//                 statusReason
//                   .trim() ||
//                 undefined,
//             },
//           );

//         toast.success(
//           "تم تحديث حالة الطلب",
//         );

//         setStatusReason(
//           "",
//         );

//         await load();
//       } catch (
//         error: any
//       ) {
//         toast.error(
//           error?.message ||
//             "فشل تحديث الحالة",
//         );
//       } finally {
//         setSaving(
//           false,
//         );
//       }
//     };

//   /* =======================================================
//    * Update Payment
//    * ===================================================== */

//   const updatePayment =
//     async () => {
//       if (
//         !orderId
//       ) {
//         return;
//       }

//       try {
//         setSaving(
//           true,
//         );

//         await ordersAdminApi
//           .updatePaymentStatus(
//             orderId,
//             {
//               paymentStatus,

//               reason:
//                 paymentReason
//                   .trim() ||
//                 undefined,
//             },
//           );

//         toast.success(
//           "تم تحديث حالة الدفع",
//         );

//         setPaymentReason(
//           "",
//         );

//         await load();
//       } catch (
//         error: any
//       ) {
//         toast.error(
//           error?.message ||
//             "فشل تحديث الدفع",
//         );
//       } finally {
//         setSaving(
//           false,
//         );
//       }
//     };

//   /* =======================================================
//    * Update Address
//    * ===================================================== */

//   const updateAddress =
//     async () => {
//       if (
//         !orderId
//       ) {
//         return;
//       }

//       if (
//         !addressId.trim()
//       ) {
//         toast.error(
//           "يرجى اختيار عنوان",
//         );

//         return;
//       }

//       try {
//         setSaving(
//           true,
//         );

//         await ordersAdminApi
//           .updateAddress(
//             orderId,
//             {
//               addressId:
//                 addressId.trim(),

//               locationName:
//                 locationName
//                   .trim() ||
//                 undefined,

//               reason:
//                 addressReason
//                   .trim() ||
//                 undefined,
//             },
//           );

//         toast.success(
//           "تم تحديث عنوان الطلب",
//         );

//         setAddressReason(
//           "",
//         );

//         await load();
//       } catch (
//         error: any
//       ) {
//         toast.error(
//           error?.message ||
//             "فشل تحديث العنوان",
//         );
//       } finally {
//         setSaving(
//           false,
//         );
//       }
//     };

//   /* =======================================================
//    * Update Items
//    * ===================================================== */

//   const updateItems =
//     async () => {
//       if (
//         !orderId
//       ) {
//         return;
//       }

//       if (
//         items.length ===
//         0
//       ) {
//         toast.error(
//           "يجب أن يحتوي الطلب على مادة واحدة على الأقل",
//         );

//         return;
//       }

//       if (
//         items.some(
//           item =>
//             !item.productId
//               .trim() ||
//             item.quantity <
//               1,
//         )
//       ) {
//         toast.error(
//           "تحقق من المنتج والكمية",
//         );

//         return;
//       }

//       try {
//         setSaving(
//           true,
//         );

//         await ordersAdminApi
//           .updateItems(
//             orderId,
//             {
//               items:
//                 items.map(
//                   item => ({
//                     productId:
//                       item.productId
//                         .trim(),

//                     quantity:
//                       Number(
//                         item.quantity,
//                       ),
//                   }),
//                 ),

//               reason:
//                 itemsReason
//                   .trim() ||
//                 undefined,
//             },
//           );

//         toast.success(
//           "تم تحديث مواد الطلب وإعادة حساب الأسعار",
//         );

//         setItemsReason(
//           "",
//         );

//         await load();
//       } catch (
//         error: any
//       ) {
//         toast.error(
//           error?.message ||
//             "فشل تحديث مواد الطلب",
//         );
//       } finally {
//         setSaving(
//           false,
//         );
//       }
//     };

//   /* =======================================================
//    * Change Item
//    * ===================================================== */

//   const changeItem =
//     (
//       index:
//         number,

//       field:
//         keyof ReplaceOrderItemInput,

//       value:
//         string |
//         number,
//     ) => {
//       setItems(
//         previous =>
//           previous.map(
//             (
//               item,
//               itemIndex,
//             ) =>
//               itemIndex ===
//               index
//                 ? {
//                     ...item,

//                     [field]:
//                       field ===
//                       "quantity"
//                         ? Number(
//                             value,
//                           )
//                         : value,
//                   }
//                 : item,
//           ),
//       );
//     };

//   /* =======================================================
//    * Loading
//    * ===================================================== */

//   if (
//     loading
//   ) {
//     return (
//       <div className="admin-orders-page">
//         <div className="admin-orders-state">
//           جاري تحميل تفاصيل الطلب...
//         </div>
//       </div>
//     );
//   }

//   if (!order) {
//     return (
//       <div className="admin-orders-page">
//         <div className="admin-orders-state">
//           الطلب غير موجود.
//         </div>
//       </div>
//     );
//   }

//   /* =======================================================
//    * Render
//    * ===================================================== */

//   return (
//     <div className="admin-orders-page">

//       {/* ===================================================
//        * Header
//        * ================================================= */}

//       <section className="admin-orders-header">
//         <div>
//           <span>
//             تفاصيل الطلب
//           </span>

//           <h1>
//             {order.orderId}
//           </h1>

//           <p>
//             إدارة الطلب ومتابعة جميع
//             التغييرات التي حدثت عليه.
//           </p>
//         </div>

//         <button
//           type="button"
//           onClick={() =>
//             navigate(
//               "/orders-admin",
//             )
//           }
//         >
//           <FontAwesomeIcon
//             icon={
//               faArrowRight
//             }
//           />

//           رجوع
//         </button>
//       </section>

//       {/* ===================================================
//        * Order Information
//        * ================================================= */}

//       <section className="admin-order-detail-grid">

//         <div className="admin-order-card">
//           <div className="admin-order-card-title">
//             <FontAwesomeIcon
//               icon={
//                 faReceipt
//               }
//             />

//             معلومات الطلب
//           </div>

//           <div className="admin-order-info-grid">

//             <div>
//               <span>
//                 المستخدم
//               </span>

//               <strong>
//                 {order.userName ||
//                   "—"}
//               </strong>
//             </div>

//             <div>
//               <span>
//                 الهاتف
//               </span>

//               <strong dir="ltr">
//                 {order.userPhone ||
//                   "—"}
//               </strong>
//             </div>

//             <div>
//               <span>
//                 البريد
//               </span>

//               <strong dir="ltr">
//                 {order.userEmail ||
//                   "—"}
//               </strong>
//             </div>

//             <div>
//               <span>
//                 إجمالي المواد
//               </span>

//               <strong>
//                 {order.totalItems}
//               </strong>
//             </div>

//             <div>
//               <span>
//                 الكمية
//               </span>

//               <strong>
//                 {order.totalQuantity}
//               </strong>
//             </div>

//             <div>
//               <span>
//                 الإجمالي
//               </span>

//               <strong>
//                 {Number(
//                   order.totalOrderPrice ||
//                     0,
//                 ).toLocaleString(
//                   "en-US",
//                 )}

//                 {" "}
//                 د.ع
//               </strong>
//             </div>

//             <div>
//               <span>
//                 تاريخ الإنشاء
//               </span>

//               <strong>
//                 {formatDate(
//                   order.createdAt,
//                 )}
//               </strong>
//             </div>

//             <div>
//               <span>
//                 الموقع
//               </span>

//               <strong>
//                 {order.locationName ||
//                   "—"}
//               </strong>
//             </div>

//           </div>

//           {order.promo && (
//             <div className="admin-order-promo">
//               <strong>
//                 Promo الشركة
//               </strong>

//               <span>
//                 Code:
//                 {" "}
//                 {
//                   order.promo
//                     .code
//                 }
//               </span>

//               <span>
//                 الحالة:
//                 {" "}
//                 {
//                   order.promo
//                     .status
//                 }
//               </span>

//               <span>
//                 الخصم:
//                 {" "}
//                 {Number(
//                   order.promo
//                     .discountAmount ||
//                     0,
//                 ).toLocaleString(
//                   "en-US",
//                 )}
//                 {" "}
//                 د.ع
//               </span>
//             </div>
//           )}
//         </div>

//         {/* =================================================
//          * Installer
//          * =============================================== */}

//         <div className="admin-order-card">
//           <div className="admin-order-card-title">
//             <FontAwesomeIcon
//               icon={faUser}
//             />

//             الفني
//           </div>

//           {order.assignedInstaller ? (
//             <div className="admin-order-installer">
//               <strong>
//                 {
//                   order
//                     .assignedInstaller
//                     .fullName
//                 }
//               </strong>

//               <span dir="ltr">
//                 {
//                   order
//                     .assignedInstaller
//                     .phoneNumber ||
//                   "—"
//                 }
//               </span>

//               <span>
//                 UID:
//                 {" "}
//                 {
//                   order
//                     .assignedInstaller
//                     .uid
//                 }
//               </span>
//             </div>
//           ) : (
//             <p>
//               لا يوجد فني معين.
//             </p>
//           )}
//         </div>

//       </section>

//       {/* ===================================================
//        * Management
//        * ================================================= */}

//       <section className="admin-order-management-grid">

//         {/* =================================================
//          * Order Status
//          * =============================================== */}

//         <div className="admin-order-card">
//           <div className="admin-order-card-title">
//             <FontAwesomeIcon
//               icon={faSave}
//             />

//             حالة الطلب
//           </div>

//           <div className="admin-order-form">
//             <select
//               value={
//                 status
//               }
//               onChange={
//                 event =>
//                   setStatus(
//                     event
//                       .target
//                       .value as
//                       OrderStatus,
//                   )
//               }
//             >
//               <option value="pending">
//                 Pending
//               </option>

//               <option value="confirmed">
//                 Confirmed
//               </option>

//               <option value="processing">
//                 Processing
//               </option>

//               <option value="completed">
//                 Completed
//               </option>

//               <option value="cancelled">
//                 Cancelled
//               </option>

//               <option value="rejected">
//                 Rejected
//               </option>
//             </select>

//             <textarea
//               rows={3}
//               value={
//                 statusReason
//               }
//               onChange={
//                 event =>
//                   setStatusReason(
//                     event
//                       .target
//                       .value,
//                   )
//               }
//               placeholder="سبب التغيير - اختياري"
//             />

//             <button
//               type="button"
//               disabled={
//                 saving
//               }
//               onClick={
//                 updateStatus
//               }
//             >
//               تحديث الحالة
//             </button>
//           </div>
//         </div>

//         {/* =================================================
//          * Payment
//          * =============================================== */}

//         <div className="admin-order-card">
//           <div className="admin-order-card-title">
//             <FontAwesomeIcon
//               icon={
//                 faCreditCard
//               }
//             />

//             حالة الدفع
//           </div>

//           <div className="admin-order-form">
//             <select
//               value={
//                 paymentStatus
//               }
//               onChange={
//                 event =>
//                   setPaymentStatus(
//                     event
//                       .target
//                       .value as
//                       PaymentStatus,
//                   )
//               }
//             >
//               <option value="pending">
//                 Pending
//               </option>

//               <option value="paid">
//                 Paid
//               </option>

//               <option value="completed">
//                 Completed
//               </option>

//               <option value="failed">
//                 Failed
//               </option>

//               <option value="partially_refunded">
//                 Partially Refunded
//               </option>

//               <option value="refunded">
//                 Refunded
//               </option>
//             </select>

//             <textarea
//               rows={3}
//               value={
//                 paymentReason
//               }
//               onChange={
//                 event =>
//                   setPaymentReason(
//                     event
//                       .target
//                       .value,
//                   )
//               }
//               placeholder="سبب التغيير - اختياري"
//             />

//             <button
//               type="button"
//               disabled={
//                 saving
//               }
//               onClick={
//                 updatePayment
//               }
//             >
//               تحديث الدفع
//             </button>
//           </div>
//         </div>

//         {/* =================================================
//          * Address
//          * =============================================== */}

//         <div className="admin-order-card">
//           <div className="admin-order-card-title">
//             <FontAwesomeIcon
//               icon={
//                 faLocationDot
//               }
//             />

//             عنوان الطلب
//           </div>

//           <div className="admin-order-current-address">
//             <span>
//               العنوان الحالي
//             </span>

//             <strong>
//               {getCurrentAddressName(
//                 order,
//               )}
//             </strong>

//             <p>
//               {getCurrentAddressDetails(
//                 order,
//               )}
//             </p>

//             {getCurrentAddressPhone(
//               order,
//             ) && (
//               <small dir="ltr">
//                 {getCurrentAddressPhone(
//                   order,
//                 )}
//               </small>
//             )}
//           </div>

//           <div className="admin-order-form">

//             <label>
//               تغيير العنوان
//             </label>

//             {addressesLoading ? (
//               <div className="admin-order-inline-loading">
//                 جاري تحميل عناوين المستخدم...
//               </div>
//             ) : userAddresses.length ===
//               0 ? (
//               <div className="admin-order-inline-warning">
//                 لا توجد عناوين مسجلة لهذا المستخدم.
//               </div>
//             ) : (
//               <select
//                 value={
//                   addressId
//                 }
//                 onChange={
//                   event => {
//                     const id =
//                       event
//                         .target
//                         .value;

//                     setAddressId(
//                       id,
//                     );

//                     const selected =
//                       userAddresses.find(
//                         address =>
//                           address.addressId ===
//                           id,
//                       );

//                     if (
//                       selected
//                     ) {
//                       setLocationName(
//                         selected.locationName ||
//                           selected.addressName ||
//                           "",
//                       );
//                     }
//                   }
//                 }
//               >
//                 <option value="">
//                   اختر عنوانًا
//                 </option>

//                 {userAddresses.map(
//                   address => (
//                     <option
//                       key={
//                         address.addressId
//                       }
//                       value={
//                         address.addressId
//                       }
//                     >
//                       {getAddressLabel(
//                         address,
//                       )}

//                       {address.isDefault
//                         ? " - الافتراضي"
//                         : ""}
//                     </option>
//                   ),
//                 )}
//               </select>
//             )}

//             {addressId && (
//               <>
//                 {(() => {
//                   const selected =
//                     userAddresses.find(
//                       item =>
//                         item.addressId ===
//                         addressId,
//                     );

//                   if (
//                     !selected
//                   ) {
//                     return null;
//                   }

//                   return (
//                     <div className="admin-order-selected-address">
//                       <strong>
//                         {selected.addressName ||
//                           selected.locationName ||
//                           "العنوان"}
//                       </strong>

//                       <span>
//                         {[
//                           selected.province,
//                           selected.City,
//                         ]
//                           .filter(
//                             Boolean,
//                           )
//                           .join(
//                             " / ",
//                           )}
//                       </span>

//                       {selected.address && (
//                         <span>
//                           {
//                             selected.address
//                           }
//                         </span>
//                       )}

//                       {selected.gate && (
//                         <span>
//                           أقرب نقطة:
//                           {" "}
//                           {
//                             selected.gate
//                           }
//                         </span>
//                       )}

//                       {selected.phoneNumber && (
//                         <span dir="ltr">
//                           {
//                             selected.phoneNumber
//                           }
//                         </span>
//                       )}

//                       {selected.isDefault && (
//                         <span>
//                           العنوان الافتراضي
//                         </span>
//                       )}
//                     </div>
//                   );
//                 })()}
//               </>
//             )}

//             <textarea
//               rows={3}
//               value={
//                 addressReason
//               }
//               onChange={
//                 event =>
//                   setAddressReason(
//                     event
//                       .target
//                       .value,
//                   )
//               }
//               placeholder="سبب تغيير العنوان - اختياري"
//             />

//             <button
//               type="button"
//               disabled={
//                 saving ||
//                 addressesLoading ||
//                 !addressId
//               }
//               onClick={
//                 updateAddress
//               }
//             >
//               تحديث العنوان
//             </button>
//           </div>
//         </div>

//       </section>

//       {/* ===================================================
//        * Order Items
//        * ================================================= */}

//       <section className="admin-order-card">
//         <div className="admin-order-card-title">
//           <FontAwesomeIcon
//             icon={
//               faBoxOpen
//             }
//           />

//           مواد الطلب
//         </div>

//         {/* =================================================
//          * Current Order Items
//          * =============================================== */}

//         {order.items &&
//           order.items.length >
//             0 && (
//             <div className="admin-order-current-products">
//               <h3>
//                 المواد الحالية في الطلب
//               </h3>

//               {order.items.map(
//                 (
//                   item,
//                   index,
//                 ) => (
//                   <div
//                     key={
//                       `${item.productId}-${index}`
//                     }
//                     className="admin-order-current-product"
//                   >
//                     {item.productImage ? (
//                       <img
//                         src={
//                           item.productImage
//                         }
//                         alt={
//                           item.productName ||
//                           ""
//                         }
//                       />
//                     ) : (
//                       <div className="admin-order-product-image-placeholder">
//                         <FontAwesomeIcon
//                           icon={
//                             faBoxOpen
//                           }
//                         />
//                       </div>
//                     )}

//                     <div>
//                       <strong>
//                         {item.productName ||
//                           "منتج"}
//                       </strong>

//                       <span>
//                         الكود:
//                         {" "}
//                         {item.code ||
//                           "غير متوفر"}
//                       </span>

//                       {item.producttype && (
//                         <span>
//                           النوع:
//                           {" "}
//                           {
//                             item.producttype
//                           }
//                         </span>
//                       )}

//                       <span>
//                         الكمية:
//                         {" "}
//                         {
//                           item.quantity
//                         }
//                       </span>

//                       <span>
//                         السعر:
//                         {" "}
//                         {Number(
//                           item.price ||
//                             0,
//                         ).toLocaleString(
//                           "en-US",
//                         )}
//                         {" "}
//                         د.ع
//                       </span>

//                       <span>
//                         الإجمالي:
//                         {" "}
//                         {Number(
//                           item.totalPrice ||
//                             0,
//                         ).toLocaleString(
//                           "en-US",
//                         )}
//                         {" "}
//                         د.ع
//                       </span>
//                     </div>
//                   </div>
//                 ),
//               )}
//             </div>
//           )}

//         {/* =================================================
//          * Product Search
//          * =============================================== */}
// <div className="admin-order-products-search">
//   <label>
//     البحث عن منتج لإضافته إلى الطلب
//   </label>

//   <div className="admin-order-product-search-input">
//     <input
//       type="text"
//       value={
//         productSearch
//       }
//       onChange={
//         event =>
//           setProductSearch(
//             event.target
//               .value,
//           )
//       }
//       placeholder="اكتب كود المنتج أو اسمه، مثال: HK-XS-8016"
//     />

//     {productsLoading && (
//       <span>
//         جاري البحث...
//       </span>
//     )}
//   </div>

//   {!productSearch.trim() && (
//     <small>
//       اكتب حرفين على الأقل للبحث في جميع منتجات النظام.
//     </small>
//   )}

//   {productSearch
//       .trim()
//       .length === 1 && (
//     <small>
//       اكتب حرفًا إضافيًا لبدء البحث.
//     </small>
//   )}

//   {!productsLoading &&
//     productSearch
//       .trim()
//       .length >= 2 &&
//     products.length >
//       0 && (
//       <small>
//         تم العثور على{" "}
//         {products.length}{" "}
//         منتج.
//       </small>
//     )}

//   {!productsLoading &&
//     productSearch
//       .trim()
//       .length >= 2 &&
//     products.length ===
//       0 && (
//       <div className="admin-order-inline-warning">
//         لم يتم العثور على منتج مطابق.
//       </div>
//     )}
// </div>
//         {/* =================================================
//          * Items Editor
//          * =============================================== */}

//         <div className="admin-order-items-editor">

//           {items.length ===
//           0 ? (
//             <div className="admin-order-inline-warning">
//               لا توجد مواد في الطلب.
//             </div>
//           ) : (
//             items.map(
//               (
//                 item,
//                 index,
//               ) => {
//                 const product =
//                   getProductById(
//                     item.productId,
//                   );

//                 const orderItem =
//                   getOrderItemByProductId(
//                     item.productId,
//                   );

//                 const productName =
//                   product?.name ||
//                   orderItem
//                     ?.productName ||
//                   "المنتج";

//                 const productCode =
//                   product?.code ||
//                   orderItem
//                     ?.code ||
//                   "غير متوفر";

//                 const productImage =
//                   product
//                     ?.imageUrl ||
//                   orderItem
//                     ?.productImage ||
//                   "";

//                 return (
//                   <div
//                     key={
//                       `${item.productId}-${index}`
//                     }
//                     className="admin-order-product-row"
//                   >

//                     {/* =====================================
//                      * Product Info
//                      * =================================== */}

//                     <div className="admin-order-product-info">
//                       {productImage ? (
//                         <img
//                           src={
//                             productImage
//                           }
//                           alt={
//                             productName
//                           }
//                         />
//                       ) : (
//                         <div className="admin-order-product-image-placeholder">
//                           <FontAwesomeIcon
//                             icon={
//                               faBoxOpen
//                             }
//                           />
//                         </div>
//                       )}

//                       <div>
//                         <strong>
//                           {
//                             productName
//                           }
//                         </strong>

//                         <span>
//                           الكود:
//                           {" "}
//                           {
//                             productCode
//                           }
//                         </span>

//                         {product &&
//                           product.stockStatus && (
//                             <span>
//                               المخزون:
//                               {" "}
//                               {
//                                 product.stockStatus
//                               }
//                             </span>
//                           )}
//                       </div>
//                     </div>

//                     {/* =====================================
//                      * Product Selector
//                      * =================================== */}

//                     <select
//                       value={
//                         item.productId
//                       }
//                       onChange={
//                         event =>
//                           changeItem(
//                             index,
//                             "productId",
//                             event
//                               .target
//                               .value,
//                           )
//                       }
//                     >
//                       <option value="">
//                         اختر المنتج
//                       </option>

//                       {products.map(
//                         productOption => (
//                           <option
//                             key={
//                               productOption.id
//                             }
//                             value={
//                               productOption.id
//                             }
//                           >
//                             {
//                               productOption.name
//                             }
//                             {" - "}
//                             {
//                               productOption.code
//                             }
//                           </option>
//                         ),
//                       )}

//                       {!products.some(
//                         productOption =>
//                           productOption.id ===
//                           item.productId,
//                       ) &&
//                         item.productId && (
//                           <option
//                             value={
//                               item.productId
//                             }
//                           >
//                             {
//                               productName
//                             }
//                             {" - "}
//                             {
//                               productCode
//                             }
//                           </option>
//                         )}
//                     </select>

//                     {/* =====================================
//                      * Quantity
//                      * =================================== */}

//                     <div className="admin-order-product-quantity">
//                       <label>
//                         الكمية
//                       </label>

//                       <input
//                         type="number"
//                         min={1}
//                         max={9999}
//                         value={
//                           item.quantity
//                         }
//                         onChange={
//                           event =>
//                             changeItem(
//                               index,
//                               "quantity",
//                               event
//                                 .target
//                                 .value,
//                             )
//                         }
//                       />
//                     </div>

//                     {/* =====================================
//                      * Remove
//                      * =================================== */}

//                     <button
//                       type="button"
//                       className="admin-order-remove-product"
//                       onClick={() =>
//                         setItems(
//                           previous =>
//                             previous.filter(
//                               (
//                                 _,
//                                 itemIndex,
//                               ) =>
//                                 itemIndex !==
//                                 index,
//                             ),
//                         )
//                       }
//                     >
//                       <FontAwesomeIcon
//                         icon={
//                           faTrash
//                         }
//                       />

//                       حذف
//                     </button>
//                   </div>
//                 );
//               },
//             )
//           )}

//           {/* =================================================
//            * Add New Item
//            * =============================================== */}

//       <button
//   type="button"
//   className="admin-order-add-item"
//   onClick={() =>
//     setItems(
//       previous => [
//         ...previous,
//         {
//           productId: "",
//           quantity: 1,
//         },
//       ],
//     )
//   }
// >
//   <FontAwesomeIcon
//     icon={faPlus}
//   />

//   إضافة مادة
// </button>

//           <textarea
//             rows={3}
//             value={
//               itemsReason
//             }
//             onChange={
//               event =>
//                 setItemsReason(
//                   event
//                     .target
//                     .value,
//                 )
//             }
//             placeholder="سبب تعديل مواد الطلب - اختياري"
//           />

//           <button
//             type="button"
//             disabled={
//               saving ||
//               items.length ===
//                 0
//             }
//             onClick={
//               updateItems
//             }
//           >
//             <FontAwesomeIcon
//               icon={faSave}
//             />

//             حفظ مواد الطلب
//           </button>

//         </div>
//       </section>

//       {/* ===================================================
//        * Status History
//        * ================================================= */}

//       <section className="admin-order-card">
//         <div className="admin-order-card-title">
//           <FontAwesomeIcon
//             icon={
//               faClockRotateLeft
//             }
//           />

//           سجل حالات الطلب
//         </div>

//         {history.length ===
//         0 ? (
//           <div className="admin-orders-state small">
//             لا يوجد سجل حالات.
//           </div>
//         ) : (
//           <div className="admin-order-history">
//             {history.map(
//               (
//                 item,
//                 index,
//               ) => (
//                 <div
//                   key={
//                     item.historyId ??
//                     item.id ??
//                     index
//                   }
//                 >
//                   <strong>
//                     {String(
//                       item.fromStatus ??
//                         item.previousStatus ??
//                         "—",
//                     )}

//                     {" → "}

//                     {String(
//                       item.toStatus ??
//                         item.status ??
//                         "—",
//                     )}
//                   </strong>

//                   <span>
//                     {item.reason ||
//                       "بدون سبب"}
//                   </span>

//                   <small>
//                     {item.changedByEmail ||
//                       item.actorEmail ||
//                       "النظام"}

//                     {" • "}

//                     {formatDate(
//                       item.createdAt,
//                     )}
//                   </small>
//                 </div>
//               ),
//             )}
//           </div>
//         )}
//       </section>

//       {/* ===================================================
//        * Timeline
//        * ================================================= */}

//       <section className="admin-order-card">
//         <div className="admin-order-card-title">
//           <FontAwesomeIcon
//             icon={
//               faTimeline
//             }
//           />

//           Timeline الكامل
//         </div>

//         {timeline.length ===
//         0 ? (
//           <div className="admin-orders-state small">
//             لا توجد أحداث.
//           </div>
//         ) : (
//           <div className="admin-order-timeline">
//             {timeline.map(
//               (
//                 item,
//                 index,
//               ) => (
//                 <div
//                   key={
//                     item.eventId ??
//                     index
//                   }
//                 >
//                   <span className="admin-order-timeline-dot" />

//                   <div>
//                     <strong>
//                       {item.type ||
//                         "event"}
//                     </strong>

//                     <p>
//                       {item.message ||
//                         item.reason ||
//                         ""}
//                     </p>

//                     <small>
//                       {item.actorType ||
//                         "system"}

//                       {" • "}

//                       {item.actorEmail ||
//                         ""}

//                       {" • "}

//                       {formatDate(
//                         item.createdAt,
//                       )}
//                     </small>
//                   </div>
//                 </div>
//               ),
//             )}
//           </div>
//         )}
//       </section>

//     </div>
//   );
// };

// export default AdminOrderDetails;

import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

import {
  FontAwesomeIcon,
} from "@fortawesome/react-fontawesome";

import {
  faArrowRight,
  faArrowRightArrowLeft,
  faBoxOpen,
  faClockRotateLeft,
  faCreditCard,
  faLocationDot,
  faPlus,
  faReceipt,
  faRotate,
  faSave,
  faTimeline,
  faTrash,
  faUser,
  faWarehouse,
} from "@fortawesome/free-solid-svg-icons";

import {
  toast,
} from "react-hot-toast";

import {
  ApiError,
} from "../api/apiError";

import {
  ordersAdminApi,
} from "../api/ordersAdminApi";

import {
  usersApi,
} from "../api/usersApi";

import {
  productsApi,
} from "../api/productsApi";

import {
  inventoryApi,
} from "../api/inventoryApi";

import {
  warehousesApi,
} from "../api/warehousesApi";

import {
  useAuth,
} from "../contexts/AuthContext";

import type {
  UserAddress,
} from "../types/users.types";

import type {
  AdminProduct,
  InventoryReservation,
  InventoryReservationsData,
} from "../types/products.types";

import type {
  WarehouseRecord,
} from "../types/warehouses.types";

import type {
  OrderItem,
  OrderRecord,
  OrderStatus,
  OrderStatusHistoryItem,
  OrderTimelineItem,
  PaymentStatus,
  ReplaceOrderItemInput,
} from "../types/orders-admin.types";

import "../screenstyles/AdminOrders.css";

/* =========================================================
 * Helpers
 * ======================================================= */

function formatDate(
  value: any,
) {
  if (!value) {
    return "—";
  }

  let date:
    | Date
    | null = null;

  if (
    typeof value ===
    "string"
  ) {
    date =
      new Date(value);
  } else {
    const seconds =
      value.seconds ??
      value._seconds;

    if (
      typeof seconds ===
      "number"
    ) {
      date =
        new Date(
          seconds *
            1000,
        );
    }
  }

  if (
    !date ||
    Number.isNaN(
      date.getTime(),
    )
  ) {
    return "—";
  }

  return new Intl.DateTimeFormat(
    "ar-IQ",
    {
      year:
        "numeric",

      month:
        "long",

      day:
        "2-digit",

      hour:
        "2-digit",

      minute:
        "2-digit",
    },
  ).format(date);
}

function getAddressLabel(
  address:
    UserAddress,
) {
  const parts = [
    address.addressName,
    address.province,
    address.City,
    address.address,
    address.gate,
  ]
    .map(
      value =>
        String(
          value ||
            "",
        ).trim(),
    )
    .filter(
      Boolean,
    );

  return (
    parts.join(" - ") ||
    address.locationName ||
    "عنوان"
  );
}

function getCurrentAddressName(
  order:
    OrderRecord,
) {
  if (
    order.address &&
    typeof order.address ===
      "object"
  ) {
    const address =
      order.address as
        Record<
          string,
          unknown
        >;

    return String(
      address.addressName ??
        address.locationName ??
        order.locationName ??
        "عنوان الطلب",
    );
  }

  return (
    order.locationName ||
    "عنوان الطلب"
  );
}

function getCurrentAddressDetails(
  order:
    OrderRecord,
) {
  if (
    !order.address ||
    typeof order.address !==
      "object"
  ) {
    return (
      order.locationName ||
      "لا توجد تفاصيل عنوان محفوظة"
    );
  }

  const address =
    order.address as
      Record<
        string,
        unknown
      >;

  return [
    address.province,
    address.City ??
      address.city,
    address.address,
    address.gate,
    address.additionalInfo,
  ]
    .map(
      value =>
        typeof value ===
        "string"
          ? value.trim()
          : "",
    )
    .filter(Boolean)
    .join(" - ");
}

function getCurrentAddressPhone(
  order:
    OrderRecord,
) {
  if (
    !order.address ||
    typeof order.address !==
      "object"
  ) {
    return "";
  }

  const address =
    order.address as
      Record<
        string,
        unknown
      >;

  return typeof address.phoneNumber ===
    "string"
    ? address.phoneNumber
    : "";
}


function getReservationStatusLabel(
  status:
    InventoryReservation["status"],
) {
  switch (status) {
    case "active":
      return "نشط";

    case "removed":
      return "تمت إزالته";

    case "released":
      return "محرر";

    case "consumed":
      return "مستهلك";

    case "cancelled":
      return "ملغي";

    default:
      return status;
  }
}

function getReservationStatusColor(
  status:
    InventoryReservation["status"],
) {
  switch (status) {
    case "active":
      return {
        background:
          "#dcfce7",
        color:
          "#166534",
      };

    case "consumed":
      return {
        background:
          "#dbeafe",
        color:
          "#1d4ed8",
      };

    case "released":
      return {
        background:
          "#fef3c7",
        color:
          "#92400e",
      };

    case "cancelled":
      return {
        background:
          "#fee2e2",
        color:
          "#991b1b",
      };

    default:
      return {
        background:
          "#e2e8f0",
        color:
          "#475569",
      };
  }
}

function createReallocationKey() {
  return [
    "order-dashboard",
    Date.now(),
    Math.random()
      .toString(36)
      .slice(2, 12),
  ].join("-");
}

function getInventoryActionError(
  error: unknown,
  fallback:
    string,
) {
  if (
    !(error instanceof
      ApiError)
  ) {
    return fallback;
  }

  switch (
    error.code
  ) {
    case "WAREHOUSE_INVENTORY_NOT_ENABLED":
      return "نظام المخزون حسب المستودعات غير مفعّل بعد. هذا طبيعي قبل تنفيذ Migration وتفعيل Warehouse Inventory.";

    case "WAREHOUSE_NOT_FOUND":
      return "المستودع المحدد غير موجود.";

    case "WAREHOUSE_INACTIVE":
      return "المستودع المحدد غير فعال.";

    case "WAREHOUSE_STOCK_NOT_FOUND":
      return "لا يوجد سجل مخزون لهذا المنتج داخل المستودع المحدد.";

    case "INSUFFICIENT_WAREHOUSE_STOCK":
    case "WAREHOUSE_STOCK_INSUFFICIENT":
      return "المخزون المتاح في المستودع الهدف غير كافٍ.";

    case "INVENTORY_RESERVATION_NOT_FOUND":
      return "حجز المخزون غير موجود.";

    case "INVENTORY_RESERVATION_NOT_ACTIVE":
      return "هذا الحجز غير نشط.";

    case "INVENTORY_RESERVATION_WAREHOUSE_REQUIRED":
      return "هذا الحجز قديم وغير مرتبط بمستودع.";

    case "INVENTORY_RESERVATION_ORDER_REQUIRED":
      return "إعادة التوزيع متاحة فقط لحجوزات الطلبات.";

    case "INVENTORY_RESERVATION_REALLOCATION_SAME_WAREHOUSE":
      return "المستودع الهدف يجب أن يكون مختلفًا عن المستودع الحالي.";

    case "INVENTORY_RESERVATION_REALLOCATION_QUANTITY_EXCEEDS_SOURCE":
      return "الكمية المطلوب نقلها أكبر من كمية الحجز.";

    case "INVENTORY_RESERVATION_REALLOCATION_LEGACY_UNSUPPORTED":
      return "هذا الحجز قديم ولا يمكن إعادة توزيعه بين المستودعات.";

    case "INVENTORY_RESERVATION_REALLOCATION_IDEMPOTENCY_CONFLICT":
    case "IDEMPOTENCY_KEY_CONFLICT":
      return "حدث تعارض في مفتاح العملية. أعد فتح نموذج إعادة التوزيع وحاول مرة أخرى.";

    case "FORBIDDEN":
      return "لا تملك الصلاحية المطلوبة لتنفيذ العملية.";

    default:
      return (
        error.message ||
        fallback
      );
  }
}

/* =========================================================
 * Component
 * ======================================================= */

const AdminOrderDetails:
React.FC = () => {
  const {
    orderId,
  } =
    useParams<{
      orderId:
        string;
    }>();

  const navigate =
    useNavigate();

  const {
    hasPermission,
  } = useAuth();

  const canViewInventory =
    hasPermission(
      "inventory.view",
    );

  const canViewWarehouses =
    hasPermission(
      "warehouses.view",
    );

  const canReallocate =
    hasPermission(
      "inventory.reallocate",
    );

  /* =======================================================
   * Order
   * ===================================================== */

  const [
    order,
    setOrder,
  ] =
    useState<
      OrderRecord |
      null
    >(null);

  const [
    history,
    setHistory,
  ] =
    useState<
      OrderStatusHistoryItem[]
    >([]);

  const [
    timeline,
    setTimeline,
  ] =
    useState<
      OrderTimelineItem[]
    >([]);

  const [
    loading,
    setLoading,
  ] =
    useState(true);

  const [
    saving,
    setSaving,
  ] =
    useState(false);

  /* =======================================================
   * Status
   * ===================================================== */

  const [
    status,
    setStatus,
  ] =
    useState<
      OrderStatus
    >(
      "pending",
    );

  const [
    statusReason,
    setStatusReason,
  ] =
    useState("");

  /* =======================================================
   * Payment
   * ===================================================== */

  const [
    paymentStatus,
    setPaymentStatus,
  ] =
    useState<
      PaymentStatus
    >(
      "pending",
    );

  const [
    paymentReason,
    setPaymentReason,
  ] =
    useState("");

  /* =======================================================
   * Address
   * ===================================================== */

  const [
    addressId,
    setAddressId,
  ] =
    useState("");

  const [
    locationName,
    setLocationName,
  ] =
    useState("");

  const [
    addressReason,
    setAddressReason,
  ] =
    useState("");

  const [
    userAddresses,
    setUserAddresses,
  ] =
    useState<
      UserAddress[]
    >([]);

  const [
    addressesLoading,
    setAddressesLoading,
  ] =
    useState(false);

  /* =======================================================
   * Items / Products
   * ===================================================== */

  const [
    items,
    setItems,
  ] =
    useState<
      ReplaceOrderItemInput[]
    >([]);

  const [
    itemsReason,
    setItemsReason,
  ] =
    useState("");

  const [
    products,
    setProducts,
  ] =
    useState<
      AdminProduct[]
    >([]);

  const [
    productsLoading,
    setProductsLoading,
  ] =
    useState(false);

  const [
    productSearch,
    setProductSearch,
  ] =
    useState("");

  /* =======================================================
   * Order Inventory / Warehouses
   * ===================================================== */

  const [
    reservations,
    setReservations,
  ] =
    useState<
      InventoryReservation[]
    >([]);

  const [
    reservationsLoading,
    setReservationsLoading,
  ] =
    useState(false);

  const [
    reservationsError,
    setReservationsError,
  ] =
    useState("");

  const [
    warehouses,
    setWarehouses,
  ] =
    useState<
      WarehouseRecord[]
    >([]);

  const [
    warehousesLoading,
    setWarehousesLoading,
  ] =
    useState(false);

  const [
    reallocationReservationId,
    setReallocationReservationId,
  ] =
    useState<
      string | null
    >(null);

  const [
    targetWarehouseId,
    setTargetWarehouseId,
  ] =
    useState("");

  const [
    reallocationQuantity,
    setReallocationQuantity,
  ] =
    useState("");

  const [
    reallocationReason,
    setReallocationReason,
  ] =
    useState("");

  const [
    reallocationKey,
    setReallocationKey,
  ] =
    useState(
      createReallocationKey(),
    );

  const [
    reallocationProcessing,
    setReallocationProcessing,
  ] =
    useState(false);

  /* =======================================================
   * Load User Addresses
   * ===================================================== */

  const loadUserAddresses =
    useCallback(
      async (
        userId:
          string,
      ) => {
        if (!userId) {
          setUserAddresses(
            [],
          );

          return;
        }

        try {
          setAddressesLoading(
            true,
          );

          const result =
            await usersApi
              .getAddresses(
                userId,
              );

          setUserAddresses(
            result.items ??
              [],
          );
        } catch (
          error
        ) {
          console.error(
            "Failed to load user addresses:",
            error,
          );

          setUserAddresses(
            [],
          );
        } finally {
          setAddressesLoading(
            false,
          );
        }
      },
      [],
    );

  /* =======================================================
   * Load Products
   * ===================================================== */

//   const loadProducts =
//     useCallback(
//       async (
//         search = "",
//       ) => {
//         try {
//           setProductsLoading(
//             true,
//           );

//           const result =
//             await productsApi
//               .adminList({
//                 search:
//                   search
//                     .trim() ||
//                   undefined,

//                 isActive:
//                   true,

//                 isDeleted:
//                   false,

//                 limit:
//                   50,

//                 sort:
//                   "createdAt_desc",
//               });

//           setProducts(
//             result.items ??
//               [],
//           );
//         } catch (
//           error
//         ) {
//           console.error(
//             "Failed to load products:",
//             error,
//           );

//           toast.error(
//             "فشل تحميل المنتجات",
//           );
//         } finally {
//           setProductsLoading(
//             false,
//           );
//         }
//       },
//       [],
//     );

const loadProducts =
  useCallback(
    async (
      search = "",
    ) => {
      try {
        setProductsLoading(
          true,
        );

        const result =
          await productsApi
            .adminList({
              search:
                search
                  .trim() ||
                undefined,

              limit:
                50,

              sort:
                "createdAt_desc",
            });

        const loadedProducts =
          result.items ??
          [];
console.log(
  "ADMIN PRODUCTS RESULT:",
  loadedProducts.map(
    product => ({
      id:
        product.id,

      code:
        product.code,

      name:
        product.name,

      quantity:
        product.quantity,

      stockStatus:
        product.stockStatus,

      showStatus:
        product.showStatus,

      showStutas:
        product.showStutas,

      isActive:
        product.isActive,

      isDeleted:
        product.isDeleted,
    }),
  ),
);
        setProducts(
          loadedProducts.filter(
            product =>
              product.isDeleted !==
              true,
          ),
        );
      } catch (
        error: any
      ) {
        console.error(
          "Failed to load products:",
          error,
        );

        setProducts(
          [],
        );

        toast.error(
          error?.message ||
            "فشل تحميل المنتجات",
        );
      } finally {
        setProductsLoading(
          false,
        );
      }
    },
    [],
  );
  /* =======================================================
   * Load Order Inventory Context
   * ===================================================== */

  const loadOrderInventory =
    useCallback(
      async () => {
        if (
          !orderId
        ) {
          return;
        }

        setReservationsError(
          "",
        );

        const jobs:
          Promise<void>[] =
          [];

        if (
          canViewInventory
        ) {
          jobs.push(
            (
              async () => {
                try {
                  setReservationsLoading(
                    true,
                  );

                  const collected:
                    InventoryReservation[] =
                    [];

                  let cursor:
                    string | undefined =
                    undefined;

                  let hasMore =
                    true;

                  let safetyPages =
                    0;

                  while (
                    hasMore &&
                    safetyPages < 20
                  ) {
                    const result:
                      InventoryReservationsData =
                      await inventoryApi
                        .getReservations({
                          orderId,
                          limit:
                            100,
                          ...(cursor
                            ? {
                                cursor,
                              }
                            : {}),
                        });

                    collected.push(
                      ...(
                        result.items ??
                        []
                      ),
                    );

                    hasMore =
                      result.hasMore ===
                      true;

                    cursor =
                      result.nextCursor ??
                      undefined;

                    safetyPages +=
                      1;

                    if (
                      hasMore &&
                      !cursor
                    ) {
                      break;
                    }
                  }

                  const map =
                    new Map<
                      string,
                      InventoryReservation
                    >();

                  collected.forEach(
                    reservation => {
                      map.set(
                        reservation.reservationId,
                        reservation,
                      );
                    },
                  );

                  setReservations(
                    Array.from(
                      map.values(),
                    ),
                  );
                } catch (
                  error
                ) {
                  console.error(
                    "Failed to load order inventory reservations:",
                    error,
                  );

                  setReservations(
                    [],
                  );

                  setReservationsError(
                    getInventoryActionError(
                      error,
                      "فشل تحميل حجوزات مخزون الطلب.",
                    ),
                  );
                } finally {
                  setReservationsLoading(
                    false,
                  );
                }
              }
            )(),
          );
        } else {
          setReservations(
            [],
          );
        }

        if (
          canViewWarehouses
        ) {
          jobs.push(
            (
              async () => {
                try {
                  setWarehousesLoading(
                    true,
                  );

                  const result =
                    await warehousesApi
                      .list({
                        isActive:
                          true,
                        sort:
                          "name_asc",
                        limit:
                          100,
                      });

                  setWarehouses(
                    result.items ??
                    [],
                  );
                } catch (
                  error
                ) {
                  console.error(
                    "Failed to load warehouses for order details:",
                    error,
                  );

                  setWarehouses(
                    [],
                  );
                } finally {
                  setWarehousesLoading(
                    false,
                  );
                }
              }
            )(),
          );
        } else {
          setWarehouses(
            [],
          );
        }

        await Promise.all(
          jobs,
        );
      },
      [
        orderId,
        canViewInventory,
        canViewWarehouses,
      ],
    );

  /* =======================================================
   * Load Order
   * ===================================================== */

  const load =
    useCallback(
      async () => {
        if (
          !orderId
        ) {
          return;
        }

        try {
          setLoading(
            true,
          );

          const [
            detailsResult,
            historyResult,
            timelineResult,
          ] =
            await Promise.all([
              ordersAdminApi
                .getById(
                  orderId,
                ),

              ordersAdminApi
                .getStatusHistory(
                  orderId,
                ),

              ordersAdminApi
                .getTimeline(
                  orderId,
                  {
                    limit:
                      100,
                  },
                ),
            ]);

          const loaded =
            detailsResult.order;

          setOrder(
            loaded,
          );

          setStatus(
            loaded.status,
          );

          setPaymentStatus(
            loaded.paymentStatus,
          );

          setAddressId(
            loaded.addressId ??
              "",
          );

          setLocationName(
            loaded.locationName ??
              "",
          );

          setHistory(
            historyResult.items ??
              [],
          );

          setTimeline(
            timelineResult.items ??
              [],
          );

          setItems(
            (
              loaded.items ??
              []
            ).map(
              (
                item:
                  OrderItem,
              ) => ({
                productId:
                  item.productId,

                quantity:
                  item.quantity,
              }),
            ),
          );
await Promise.all([
  loadUserAddresses(
    loaded.userId,
  ),
  loadOrderInventory(),
]);
        } catch (
          error
        ) {
          console.error(
            "Failed loading order:",
            error,
          );

          if (
            error instanceof
            ApiError
          ) {
            toast.error(
              error.message ||
                "فشل تحميل الطلب",
            );

            return;
          }

          toast.error(
            "تعذر الاتصال بالخادم",
          );
        } finally {
          setLoading(
            false,
          );
        }
      },
     [
  orderId,
  loadUserAddresses,
  loadOrderInventory,
],
    );

  useEffect(() => {
    load();
  }, [
    load,
  ]);

  /* =======================================================
   * Product Search
   * ===================================================== */

  useEffect(() => {
  const searchValue =
    productSearch.trim();

  if (
    searchValue.length <
    2
  ) {
    setProducts(
      [],
    );

    return;
  }

  const timer =
    window.setTimeout(
      () => {
        loadProducts(
          searchValue,
        );
      },
      400,
    );

  return () =>
    window.clearTimeout(
      timer,
    );
}, [
  productSearch,
  loadProducts,
]);

  /* =======================================================
   * Find Product
   * ===================================================== */

  const getProductById =
    (
      productId:
        string,
    ) => {
      return (
        products.find(
          product =>
            product.id ===
            productId,
        ) ??
        null
      );
    };

  const getOrderItemByProductId =
    (
      productId:
        string,
    ) => {
      return (
        order?.items?.find(
          item =>
            item.productId ===
            productId,
        ) ??
        null
      );
    };

  /* =======================================================
   * Update Status
   * ===================================================== */

  const updateStatus =
    async () => {
      if (
        !orderId
      ) {
        return;
      }

      try {
        setSaving(
          true,
        );

        await ordersAdminApi
          .updateStatus(
            orderId,
            {
              status,

              reason:
                statusReason
                  .trim() ||
                undefined,
            },
          );

        toast.success(
          "تم تحديث حالة الطلب",
        );

        setStatusReason(
          "",
        );

        await load();
      } catch (
        error: any
      ) {
        toast.error(
          error?.message ||
            "فشل تحديث الحالة",
        );
      } finally {
        setSaving(
          false,
        );
      }
    };

  /* =======================================================
   * Update Payment
   * ===================================================== */

  const updatePayment =
    async () => {
      if (
        !orderId
      ) {
        return;
      }

      try {
        setSaving(
          true,
        );

        await ordersAdminApi
          .updatePaymentStatus(
            orderId,
            {
              paymentStatus,

              reason:
                paymentReason
                  .trim() ||
                undefined,
            },
          );

        toast.success(
          "تم تحديث حالة الدفع",
        );

        setPaymentReason(
          "",
        );

        await load();
      } catch (
        error: any
      ) {
        toast.error(
          error?.message ||
            "فشل تحديث الدفع",
        );
      } finally {
        setSaving(
          false,
        );
      }
    };

  /* =======================================================
   * Update Address
   * ===================================================== */

  const updateAddress =
    async () => {
      if (
        !orderId
      ) {
        return;
      }

      if (
        !addressId.trim()
      ) {
        toast.error(
          "يرجى اختيار عنوان",
        );

        return;
      }

      try {
        setSaving(
          true,
        );

        await ordersAdminApi
          .updateAddress(
            orderId,
            {
              addressId:
                addressId.trim(),

              locationName:
                locationName
                  .trim() ||
                undefined,

              reason:
                addressReason
                  .trim() ||
                undefined,
            },
          );

        toast.success(
          "تم تحديث عنوان الطلب",
        );

        setAddressReason(
          "",
        );

        await load();
      } catch (
        error: any
      ) {
        toast.error(
          error?.message ||
            "فشل تحديث العنوان",
        );
      } finally {
        setSaving(
          false,
        );
      }
    };

  /* =======================================================
   * Update Items
   * ===================================================== */

  const updateItems =
    async () => {
      if (
        !orderId
      ) {
        return;
      }

      if (
        items.length ===
        0
      ) {
        toast.error(
          "يجب أن يحتوي الطلب على مادة واحدة على الأقل",
        );

        return;
      }

      if (
        items.some(
          item =>
            !item.productId
              .trim() ||
            item.quantity <
              1,
        )
      ) {
        toast.error(
          "تحقق من المنتج والكمية",
        );

        return;
      }

      try {
        setSaving(
          true,
        );

        await ordersAdminApi
          .updateItems(
            orderId,
            {
              items:
                items.map(
                  item => ({
                    productId:
                      item.productId
                        .trim(),

                    quantity:
                      Number(
                        item.quantity,
                      ),
                  }),
                ),

              reason:
                itemsReason
                  .trim() ||
                undefined,
            },
          );

        toast.success(
          "تم تحديث مواد الطلب وإعادة حساب الأسعار",
        );

        setItemsReason(
          "",
        );

        await load();
      } catch (
        error: any
      ) {
        toast.error(
          error?.message ||
            "فشل تحديث مواد الطلب",
        );
      } finally {
        setSaving(
          false,
        );
      }
    };

  /* =======================================================
   * Change Item
   * ===================================================== */

  const changeItem =
    (
      index:
        number,

      field:
        keyof ReplaceOrderItemInput,

      value:
        string |
        number,
    ) => {
      setItems(
        previous =>
          previous.map(
            (
              item,
              itemIndex,
            ) =>
              itemIndex ===
              index
                ? {
                    ...item,

                    [field]:
                      field ===
                      "quantity"
                        ? Number(
                            value,
                          )
                        : value,
                  }
                : item,
          ),
      );
    };

  /* =======================================================
   * Inventory Derived Data
   * ===================================================== */

  const warehouseMap =
    useMemo(
      () =>
        new Map(
          warehouses.map(
            warehouse => [
              warehouse.id,
              warehouse,
            ],
          ),
        ),
      [
        warehouses,
      ],
    );

  const getWarehouseName =
    useCallback(
      (
        warehouseId:
          string |
          null |
          undefined,
      ) => {
        if (
          !warehouseId
        ) {
          return "قديم / بدون مستودع";
        }

        const warehouse =
          warehouseMap.get(
            warehouseId,
          );

        return (
          warehouse?.nameAr ||
          warehouse?.name ||
          warehouseId
        );
      },
      [
        warehouseMap,
      ],
    );

  const reservationsByProductId =
    useMemo(
      () => {
        const map =
          new Map<
            string,
            InventoryReservation[]
          >();

        reservations.forEach(
          reservation => {
            const current =
              map.get(
                reservation.productId,
              ) ??
              [];

            current.push(
              reservation,
            );

            map.set(
              reservation.productId,
              current,
            );
          },
        );

        return map;
      },
      [
        reservations,
      ],
    );

  const activeReservationsCount =
    useMemo(
      () =>
        reservations.filter(
          reservation =>
            reservation.status ===
            "active",
        ).length,
      [
        reservations,
      ],
    );

  const consumedReservationsCount =
    useMemo(
      () =>
        reservations.filter(
          reservation =>
            reservation.status ===
            "consumed",
        ).length,
      [
        reservations,
      ],
    );

  const legacyReservationsCount =
    useMemo(
      () =>
        reservations.filter(
          reservation =>
            !reservation.warehouseId,
        ).length,
      [
        reservations,
      ],
    );

  const openReallocation =
    (
      reservation:
        InventoryReservation,
    ) => {
      setReallocationReservationId(
        reservation.reservationId,
      );

      setTargetWarehouseId(
        "",
      );

      setReallocationQuantity(
        "",
      );

      setReallocationReason(
        "",
      );

      setReallocationKey(
        createReallocationKey(),
      );
    };

  const closeReallocation =
    () => {
      if (
        reallocationProcessing
      ) {
        return;
      }

      setReallocationReservationId(
        null,
      );

      setTargetWarehouseId(
        "",
      );

      setReallocationQuantity(
        "",
      );

      setReallocationReason(
        "",
      );

      setReallocationKey(
        createReallocationKey(),
      );
    };

  const reallocateReservation =
    async (
      reservation:
        InventoryReservation,
    ) => {
      if (
        reservation.status !==
        "active"
      ) {
        toast.error(
          "الحجز غير نشط.",
        );

        return;
      }

      if (
        !reservation.warehouseId
      ) {
        toast.error(
          "هذا الحجز قديم وغير مرتبط بمستودع.",
        );

        return;
      }

      if (
        !targetWarehouseId
          .trim()
      ) {
        toast.error(
          "اختر المستودع الهدف.",
        );

        return;
      }

      if (
        targetWarehouseId ===
        reservation.warehouseId
      ) {
        toast.error(
          "المستودع الهدف يجب أن يكون مختلفًا عن المستودع الحالي.",
        );

        return;
      }

      const reason =
        reallocationReason
          .trim();

      if (!reason) {
        toast.error(
          "أدخل سبب إعادة توزيع الحجز.",
        );

        return;
      }

      let quantity:
        number |
        undefined;

      if (
        reallocationQuantity
          .trim()
      ) {
        quantity =
          Number(
            reallocationQuantity,
          );

        if (
          !Number.isInteger(
            quantity,
          ) ||
          quantity <= 0
        ) {
          toast.error(
            "كمية النقل يجب أن تكون رقمًا صحيحًا أكبر من صفر.",
          );

          return;
        }

        if (
          quantity >
          reservation.quantity
        ) {
          toast.error(
            "كمية النقل أكبر من كمية الحجز.",
          );

          return;
        }
      }

      try {
        setReallocationProcessing(
          true,
        );

        const result =
          await inventoryApi
            .reallocateReservation(
              reservation.reservationId,
              {
                idempotencyKey:
                  reallocationKey,

                targetWarehouseId:
                  targetWarehouseId
                    .trim(),

                ...(quantity !==
                undefined
                  ? {
                      quantity,
                    }
                  : {}),

                reason,
              },
            );

        toast.success(
          `تم نقل ${result.reallocation.quantity} من ${getWarehouseName(
            result.reallocation.sourceWarehouseId,
          )} إلى ${getWarehouseName(
            result.reallocation.targetWarehouseId,
          )}.`,
        );

        closeReallocation();

        await loadOrderInventory();
      } catch (
        error
      ) {
        console.error(
          "Order reservation reallocation failed:",
          error,
        );

        toast.error(
          getInventoryActionError(
            error,
            "فشل إعادة توزيع حجز المخزون.",
          ),
        );
      } finally {
        setReallocationProcessing(
          false,
        );
      }
    };

  /* =======================================================
   * Loading
   * ===================================================== */

  if (
    loading
  ) {
    return (
      <div className="admin-orders-page">
        <div className="admin-orders-state">
          جاري تحميل تفاصيل الطلب...
        </div>
      </div>
    );
  }

  if (!order) {
    return (
      <div className="admin-orders-page">
        <div className="admin-orders-state">
          الطلب غير موجود.
        </div>
      </div>
    );
  }

  /* =======================================================
   * Render
   * ===================================================== */

  return (
    <div className="admin-orders-page">

      {/* ===================================================
       * Header
       * ================================================= */}

      <section className="admin-orders-header">
        <div>
          <span>
            تفاصيل الطلب
          </span>

          <h1>
            {order.orderId}
          </h1>

          <p>
            إدارة الطلب ومتابعة جميع
            التغييرات التي حدثت عليه.
          </p>
        </div>

        <button
          type="button"
          onClick={() =>
            navigate(
              "/orders-admin",
            )
          }
        >
          <FontAwesomeIcon
            icon={
              faArrowRight
            }
          />

          رجوع
        </button>
      </section>

      {/* ===================================================
       * Order Information
       * ================================================= */}

      <section className="admin-order-detail-grid">

        <div className="admin-order-card">
          <div className="admin-order-card-title">
            <FontAwesomeIcon
              icon={
                faReceipt
              }
            />

            معلومات الطلب
          </div>

          <div className="admin-order-info-grid">

            <div>
              <span>
                المستخدم
              </span>

              <strong>
                {order.userName ||
                  "—"}
              </strong>
            </div>

            <div>
              <span>
                الهاتف
              </span>

              <strong dir="ltr">
                {order.userPhone ||
                  "—"}
              </strong>
            </div>

            <div>
              <span>
                البريد
              </span>

              <strong dir="ltr">
                {order.userEmail ||
                  "—"}
              </strong>
            </div>

            <div>
              <span>
                إجمالي المواد
              </span>

              <strong>
                {order.totalItems}
              </strong>
            </div>

            <div>
              <span>
                الكمية
              </span>

              <strong>
                {order.totalQuantity}
              </strong>
            </div>

            <div>
              <span>
                الإجمالي
              </span>

              <strong>
                {Number(
                  order.totalOrderPrice ||
                    0,
                ).toLocaleString(
                  "en-US",
                )}

                {" "}
                د.ع
              </strong>
            </div>

            <div>
              <span>
                تاريخ الإنشاء
              </span>

              <strong>
                {formatDate(
                  order.createdAt,
                )}
              </strong>
            </div>

            <div>
              <span>
                الموقع
              </span>

              <strong>
                {order.locationName ||
                  "—"}
              </strong>
            </div>

          </div>

          {order.promo && (
            <div className="admin-order-promo">
              <strong>
                Promo الشركة
              </strong>

              <span>
                Code:
                {" "}
                {
                  order.promo
                    .code
                }
              </span>

              <span>
                الحالة:
                {" "}
                {
                  order.promo
                    .status
                }
              </span>

              <span>
                الخصم:
                {" "}
                {Number(
                  order.promo
                    .discountAmount ||
                    0,
                ).toLocaleString(
                  "en-US",
                )}
                {" "}
                د.ع
              </span>
            </div>
          )}
        </div>

        {/* =================================================
         * Installer
         * =============================================== */}

        <div className="admin-order-card">
          <div className="admin-order-card-title">
            <FontAwesomeIcon
              icon={faUser}
            />

            الفني
          </div>

          {order.assignedInstaller ? (
            <div className="admin-order-installer">
              <strong>
                {
                  order
                    .assignedInstaller
                    .fullName
                }
              </strong>

              <span dir="ltr">
                {
                  order
                    .assignedInstaller
                    .phoneNumber ||
                  "—"
                }
              </span>

              <span>
                UID:
                {" "}
                {
                  order
                    .assignedInstaller
                    .uid
                }
              </span>
            </div>
          ) : (
            <p>
              لا يوجد فني معين.
            </p>
          )}
        </div>

      </section>

      {/* ===================================================
       * Management
       * ================================================= */}

      <section className="admin-order-management-grid">

        {/* =================================================
         * Order Status
         * =============================================== */}

        <div className="admin-order-card">
          <div className="admin-order-card-title">
            <FontAwesomeIcon
              icon={faSave}
            />

            حالة الطلب
          </div>

          <div className="admin-order-form">
            <select
              value={
                status
              }
              onChange={
                event =>
                  setStatus(
                    event
                      .target
                      .value as
                      OrderStatus,
                  )
              }
            >
              <option value="pending">
                Pending
              </option>

              <option value="confirmed">
                Confirmed
              </option>

              <option value="processing">
                Processing
              </option>

              <option value="completed">
                Completed
              </option>

              <option value="cancelled">
                Cancelled
              </option>

              <option value="rejected">
                Rejected
              </option>
            </select>

            <textarea
              rows={3}
              value={
                statusReason
              }
              onChange={
                event =>
                  setStatusReason(
                    event
                      .target
                      .value,
                  )
              }
              placeholder="سبب التغيير - اختياري"
            />

            <button
              type="button"
              disabled={
                saving
              }
              onClick={
                updateStatus
              }
            >
              تحديث الحالة
            </button>
          </div>
        </div>

        {/* =================================================
         * Payment
         * =============================================== */}

        <div className="admin-order-card">
          <div className="admin-order-card-title">
            <FontAwesomeIcon
              icon={
                faCreditCard
              }
            />

            حالة الدفع
          </div>

          <div className="admin-order-form">
            <select
              value={
                paymentStatus
              }
              onChange={
                event =>
                  setPaymentStatus(
                    event
                      .target
                      .value as
                      PaymentStatus,
                  )
              }
            >
              <option value="pending">
                Pending
              </option>

              <option value="paid">
                Paid
              </option>

              <option value="completed">
                Completed
              </option>

              <option value="failed">
                Failed
              </option>

              <option value="partially_refunded">
                Partially Refunded
              </option>

              <option value="refunded">
                Refunded
              </option>
            </select>

            <textarea
              rows={3}
              value={
                paymentReason
              }
              onChange={
                event =>
                  setPaymentReason(
                    event
                      .target
                      .value,
                  )
              }
              placeholder="سبب التغيير - اختياري"
            />

            <button
              type="button"
              disabled={
                saving
              }
              onClick={
                updatePayment
              }
            >
              تحديث الدفع
            </button>
          </div>
        </div>

        {/* =================================================
         * Address
         * =============================================== */}

        <div className="admin-order-card">
          <div className="admin-order-card-title">
            <FontAwesomeIcon
              icon={
                faLocationDot
              }
            />

            عنوان الطلب
          </div>

          <div className="admin-order-current-address">
            <span>
              العنوان الحالي
            </span>

            <strong>
              {getCurrentAddressName(
                order,
              )}
            </strong>

            <p>
              {getCurrentAddressDetails(
                order,
              )}
            </p>

            {getCurrentAddressPhone(
              order,
            ) && (
              <small dir="ltr">
                {getCurrentAddressPhone(
                  order,
                )}
              </small>
            )}
          </div>

          <div className="admin-order-form">

            <label>
              تغيير العنوان
            </label>

            {addressesLoading ? (
              <div className="admin-order-inline-loading">
                جاري تحميل عناوين المستخدم...
              </div>
            ) : userAddresses.length ===
              0 ? (
              <div className="admin-order-inline-warning">
                لا توجد عناوين مسجلة لهذا المستخدم.
              </div>
            ) : (
              <select
                value={
                  addressId
                }
                onChange={
                  event => {
                    const id =
                      event
                        .target
                        .value;

                    setAddressId(
                      id,
                    );

                    const selected =
                      userAddresses.find(
                        address =>
                          address.addressId ===
                          id,
                      );

                    if (
                      selected
                    ) {
                      setLocationName(
                        selected.locationName ||
                          selected.addressName ||
                          "",
                      );
                    }
                  }
                }
              >
                <option value="">
                  اختر عنوانًا
                </option>

                {userAddresses.map(
                  address => (
                    <option
                      key={
                        address.addressId
                      }
                      value={
                        address.addressId
                      }
                    >
                      {getAddressLabel(
                        address,
                      )}

                      {address.isDefault
                        ? " - الافتراضي"
                        : ""}
                    </option>
                  ),
                )}
              </select>
            )}

            {addressId && (
              <>
                {(() => {
                  const selected =
                    userAddresses.find(
                      item =>
                        item.addressId ===
                        addressId,
                    );

                  if (
                    !selected
                  ) {
                    return null;
                  }

                  return (
                    <div className="admin-order-selected-address">
                      <strong>
                        {selected.addressName ||
                          selected.locationName ||
                          "العنوان"}
                      </strong>

                      <span>
                        {[
                          selected.province,
                          selected.City,
                        ]
                          .filter(
                            Boolean,
                          )
                          .join(
                            " / ",
                          )}
                      </span>

                      {selected.address && (
                        <span>
                          {
                            selected.address
                          }
                        </span>
                      )}

                      {selected.gate && (
                        <span>
                          أقرب نقطة:
                          {" "}
                          {
                            selected.gate
                          }
                        </span>
                      )}

                      {selected.phoneNumber && (
                        <span dir="ltr">
                          {
                            selected.phoneNumber
                          }
                        </span>
                      )}

                      {selected.isDefault && (
                        <span>
                          العنوان الافتراضي
                        </span>
                      )}
                    </div>
                  );
                })()}
              </>
            )}

            <textarea
              rows={3}
              value={
                addressReason
              }
              onChange={
                event =>
                  setAddressReason(
                    event
                      .target
                      .value,
                  )
              }
              placeholder="سبب تغيير العنوان - اختياري"
            />

            <button
              type="button"
              disabled={
                saving ||
                addressesLoading ||
                !addressId
              }
              onClick={
                updateAddress
              }
            >
              تحديث العنوان
            </button>
          </div>
        </div>

      </section>

      {/* ===================================================
       * Order Items
       * ================================================= */}

      <section className="admin-order-card">
        <div className="admin-order-card-title">
          <FontAwesomeIcon
            icon={
              faBoxOpen
            }
          />

          مواد الطلب
        </div>

        {/* =================================================
         * Current Order Items
         * =============================================== */}

        {order.items &&
          order.items.length >
            0 && (
            <div className="admin-order-current-products">
              <h3>
                المواد الحالية في الطلب
              </h3>

              {order.items.map(
                (
                  item,
                  index,
                ) => (
                  <div
                    key={
                      `${item.productId}-${index}`
                    }
                    className="admin-order-current-product"
                  >
                    {item.productImage ? (
                      <img
                        src={
                          item.productImage
                        }
                        alt={
                          item.productName ||
                          ""
                        }
                      />
                    ) : (
                      <div className="admin-order-product-image-placeholder">
                        <FontAwesomeIcon
                          icon={
                            faBoxOpen
                          }
                        />
                      </div>
                    )}

                    <div>
                      <strong>
                        {item.productName ||
                          "منتج"}
                      </strong>

                      <span>
                        الكود:
                        {" "}
                        {item.code ||
                          "غير متوفر"}
                      </span>

                      {item.producttype && (
                        <span>
                          النوع:
                          {" "}
                          {
                            item.producttype
                          }
                        </span>
                      )}

                      <span>
                        الكمية:
                        {" "}
                        {
                          item.quantity
                        }
                      </span>

                      {canViewInventory && (
                        <span>
                          الحجز النشط:
                          {" "}
                          {(
                            reservationsByProductId.get(
                              item.productId,
                            ) ??
                            []
                          )
                            .filter(
                              reservation =>
                                reservation.status ===
                                "active",
                            )
                            .reduce(
                              (
                                total,
                                reservation,
                              ) =>
                                total +
                                reservation.quantity,
                              0,
                            )}
                        </span>
                      )}

                      <span>
                        السعر:
                        {" "}
                        {Number(
                          item.price ||
                            0,
                        ).toLocaleString(
                          "en-US",
                        )}
                        {" "}
                        د.ع
                      </span>

                      <span>
                        الإجمالي:
                        {" "}
                        {Number(
                          item.totalPrice ||
                            0,
                        ).toLocaleString(
                          "en-US",
                        )}
                        {" "}
                        د.ع
                      </span>
                    </div>
                  </div>
                ),
              )}
            </div>
          )}

        {/* =================================================
         * Product Search
         * =============================================== */}
<div className="admin-order-products-search">
  <label>
    البحث عن منتج لإضافته إلى الطلب
  </label>

  <div className="admin-order-product-search-input">
    <input
      type="text"
      value={
        productSearch
      }
      onChange={
        event =>
          setProductSearch(
            event.target
              .value,
          )
      }
      placeholder="اكتب كود المنتج أو اسمه، مثال: HK-XS-8016"
    />

    {productsLoading && (
      <span>
        جاري البحث...
      </span>
    )}
  </div>

  {!productSearch.trim() && (
    <small>
      اكتب حرفين على الأقل للبحث في جميع منتجات النظام.
    </small>
  )}

  {productSearch
      .trim()
      .length === 1 && (
    <small>
      اكتب حرفًا إضافيًا لبدء البحث.
    </small>
  )}

  {!productsLoading &&
    productSearch
      .trim()
      .length >= 2 &&
    products.length >
      0 && (
      <small>
        تم العثور على{" "}
        {products.length}{" "}
        منتج.
      </small>
    )}

  {!productsLoading &&
    productSearch
      .trim()
      .length >= 2 &&
    products.length ===
      0 && (
      <div className="admin-order-inline-warning">
        لم يتم العثور على منتج مطابق.
      </div>
    )}
</div>
        {/* =================================================
         * Items Editor
         * =============================================== */}

        <div className="admin-order-items-editor">

          {items.length ===
          0 ? (
            <div className="admin-order-inline-warning">
              لا توجد مواد في الطلب.
            </div>
          ) : (
            items.map(
              (
                item,
                index,
              ) => {
                const product =
                  getProductById(
                    item.productId,
                  );

                const orderItem =
                  getOrderItemByProductId(
                    item.productId,
                  );

                const productName =
                  product?.name ||
                  orderItem
                    ?.productName ||
                  "المنتج";

                const productCode =
                  product?.code ||
                  orderItem
                    ?.code ||
                  "غير متوفر";

                const productImage =
                  product
                    ?.imageUrl ||
                  orderItem
                    ?.productImage ||
                  "";

                return (
                  <div
                    key={
                      `${item.productId}-${index}`
                    }
                    className="admin-order-product-row"
                  >

                    {/* =====================================
                     * Product Info
                     * =================================== */}

                    <div className="admin-order-product-info">
                      {productImage ? (
                        <img
                          src={
                            productImage
                          }
                          alt={
                            productName
                          }
                        />
                      ) : (
                        <div className="admin-order-product-image-placeholder">
                          <FontAwesomeIcon
                            icon={
                              faBoxOpen
                            }
                          />
                        </div>
                      )}

                      <div>
                        <strong>
                          {
                            productName
                          }
                        </strong>

                        <span>
                          الكود:
                          {" "}
                          {
                            productCode
                          }
                        </span>

                        {product &&
                          product.stockStatus && (
                            <span>
                              المخزون:
                              {" "}
                              {
                                product.stockStatus
                              }
                            </span>
                          )}
                      </div>
                    </div>

                    {/* =====================================
                     * Product Selector
                     * =================================== */}

                    <select
                      value={
                        item.productId
                      }
                      onChange={
                        event =>
                          changeItem(
                            index,
                            "productId",
                            event
                              .target
                              .value,
                          )
                      }
                    >
                      <option value="">
                        اختر المنتج
                      </option>

                      {products.map(
                        productOption => (
                          <option
                            key={
                              productOption.id
                            }
                            value={
                              productOption.id
                            }
                          >
                            {
                              productOption.name
                            }
                            {" - "}
                            {
                              productOption.code
                            }
                          </option>
                        ),
                      )}

                      {!products.some(
                        productOption =>
                          productOption.id ===
                          item.productId,
                      ) &&
                        item.productId && (
                          <option
                            value={
                              item.productId
                            }
                          >
                            {
                              productName
                            }
                            {" - "}
                            {
                              productCode
                            }
                          </option>
                        )}
                    </select>

                    {/* =====================================
                     * Quantity
                     * =================================== */}

                    <div className="admin-order-product-quantity">
                      <label>
                        الكمية
                      </label>

                      <input
                        type="number"
                        min={1}
                        max={9999}
                        value={
                          item.quantity
                        }
                        onChange={
                          event =>
                            changeItem(
                              index,
                              "quantity",
                              event
                                .target
                                .value,
                            )
                        }
                      />
                    </div>

                    {/* =====================================
                     * Remove
                     * =================================== */}

                    <button
                      type="button"
                      className="admin-order-remove-product"
                      onClick={() =>
                        setItems(
                          previous =>
                            previous.filter(
                              (
                                _,
                                itemIndex,
                              ) =>
                                itemIndex !==
                                index,
                            ),
                        )
                      }
                    >
                      <FontAwesomeIcon
                        icon={
                          faTrash
                        }
                      />

                      حذف
                    </button>
                  </div>
                );
              },
            )
          )}

          {/* =================================================
           * Add New Item
           * =============================================== */}

      <button
  type="button"
  className="admin-order-add-item"
  onClick={() =>
    setItems(
      previous => [
        ...previous,
        {
          productId: "",
          quantity: 1,
        },
      ],
    )
  }
>
  <FontAwesomeIcon
    icon={faPlus}
  />

  إضافة مادة
</button>

          <textarea
            rows={3}
            value={
              itemsReason
            }
            onChange={
              event =>
                setItemsReason(
                  event
                    .target
                    .value,
                )
            }
            placeholder="سبب تعديل مواد الطلب - اختياري"
          />

          <button
            type="button"
            disabled={
              saving ||
              items.length ===
                0
            }
            onClick={
              updateItems
            }
          >
            <FontAwesomeIcon
              icon={faSave}
            />

            حفظ مواد الطلب
          </button>

        </div>
      </section>


      {/* ===================================================
       * Order Inventory / Warehouse Reservations
       * ================================================= */}

      <section className="admin-order-card">

        <div className="admin-order-card-title">

          <FontAwesomeIcon
            icon={
              faWarehouse
            }
          />

          توزيع مخزون الطلب والمستودعات

          <button
            type="button"
            onClick={
              loadOrderInventory
            }
            disabled={
              reservationsLoading ||
              warehousesLoading
            }
            title="تحديث بيانات المخزون"
            style={{
              marginRight:
                "auto",

              border:
                "1px solid #dbe4ea",

              borderRadius:
                "8px",

              background:
                "#fff",

              padding:
                "7px 10px",

              cursor:
                "pointer",
            }}
          >
            <FontAwesomeIcon
              icon={
                faRotate
              }
            />

            {" "}
            تحديث
          </button>

        </div>


        {!canViewInventory ? (

          <div className="admin-order-inline-warning">
            لا تملك صلاحية inventory.view لعرض حجوزات مخزون هذا الطلب.
          </div>

        ) : reservationsLoading ? (

          <div className="admin-orders-state small">
            جاري تحميل حجوزات مخزون الطلب...
          </div>

        ) : reservationsError ? (

          <div className="admin-order-inline-warning">
            {reservationsError}
          </div>

        ) : (

          <>

            <div
              className="admin-order-info-grid"
              style={{
                marginBottom:
                  "18px",
              }}
            >

              <div>
                <span>
                  إجمالي الحجوزات
                </span>

                <strong>
                  {reservations.length}
                </strong>
              </div>


              <div>
                <span>
                  الحجوزات النشطة
                </span>

                <strong>
                  {activeReservationsCount}
                </strong>
              </div>


              <div>
                <span>
                  الحجوزات المستهلكة
                </span>

                <strong>
                  {consumedReservationsCount}
                </strong>
              </div>


              <div>
                <span>
                  حجوزات قديمة بدون مستودع
                </span>

                <strong>
                  {legacyReservationsCount}
                </strong>
              </div>

            </div>


            {reservations.length ===
            0 ? (

              <div className="admin-orders-state small">

                لا توجد حجوزات مخزون مرتبطة بهذا الطلب حاليًا.

                <br />

                <small>
                  قبل تفعيل Warehouse Inventory قد تكون بعض الطلبات القديمة بدون حجوزات مرتبطة بمستودعات.
                </small>

              </div>

            ) : (

              <div
                style={{
                  display:
                    "grid",

                  gap:
                    "14px",
                }}
              >

                {reservations.map(
                  reservation => {

                    const statusStyle =
                      getReservationStatusColor(
                        reservation.status,
                      );

                    const currentWarehouseName =
                      getWarehouseName(
                        reservation.warehouseId,
                      );

                    const isReallocationOpen =
                      reallocationReservationId ===
                      reservation.reservationId;

                    return (

                      <div
                        key={
                          reservation.reservationId
                        }
                        style={{
                          border:
                            "1px solid #e2e8f0",

                          borderRadius:
                            "14px",

                          padding:
                            "14px",

                          background:
                            "#fff",
                        }}
                      >

                        <div
                          style={{
                            display:
                              "flex",

                            alignItems:
                              "flex-start",

                            justifyContent:
                              "space-between",

                            gap:
                              "12px",

                            flexWrap:
                              "wrap",
                          }}
                        >

                          <div>

                            <strong
                              style={{
                                display:
                                  "block",

                                marginBottom:
                                  "5px",
                              }}
                            >
                              {reservation.productName ||
                                "منتج"}
                            </strong>

                            <span>
                              {reservation.productCode ||
                                reservation.productId}
                            </span>

                          </div>


                          <span
                            style={{
                              ...statusStyle,

                              borderRadius:
                                "999px",

                              padding:
                                "5px 10px",

                              fontSize:
                                "12px",

                              fontWeight:
                                800,
                            }}
                          >
                            {getReservationStatusLabel(
                              reservation.status,
                            )}
                          </span>

                        </div>


                        <div
                          className="admin-order-info-grid"
                          style={{
                            marginTop:
                              "14px",
                          }}
                        >

                          <div>
                            <span>
                              المستودع
                            </span>

                            <strong>
                              {currentWarehouseName}
                            </strong>
                          </div>


                          <div>
                            <span>
                              الكمية المحجوزة
                            </span>

                            <strong>
                              {reservation.quantity}
                            </strong>
                          </div>


                          <div>
                            <span>
                              Reservation ID
                            </span>

                            <strong
                              dir="ltr"
                              style={{
                                wordBreak:
                                  "break-all",
                              }}
                            >
                              {reservation.reservationId}
                            </strong>
                          </div>


                          <div>
                            <span>
                              Transaction ID
                            </span>

                            <strong
                              dir="ltr"
                              style={{
                                wordBreak:
                                  "break-all",
                              }}
                            >
                              {reservation.transactionId ||
                                "—"}
                            </strong>
                          </div>


                          <div>
                            <span>
                              تاريخ الحجز
                            </span>

                            <strong>
                              {formatDate(
                                reservation.reservedAt,
                              )}
                            </strong>
                          </div>


                          <div>
                            <span>
                              آخر تحديث
                            </span>

                            <strong>
                              {formatDate(
                                reservation.updatedAt,
                              )}
                            </strong>
                          </div>

                        </div>


                        <div
                          style={{
                            marginTop:
                              "12px",

                            padding:
                              "10px 12px",

                            borderRadius:
                              "10px",

                            background:
                              "#f8fafc",
                          }}
                        >
                          <strong>
                            سبب الحجز:
                          </strong>

                          {" "}

                          {reservation.reason ||
                            "بدون سبب"}
                        </div>


                        {reservation.status ===
                          "active" &&
                          !reservation.warehouseId && (

                          <div
                            className="admin-order-inline-warning"
                            style={{
                              marginTop:
                                "12px",
                            }}
                          >
                            هذا حجز قديم بدون Warehouse ID، لذلك لا يمكن إعادة توزيعه بين المستودعات.
                          </div>

                        )}


                        {reservation.status ===
                          "active" &&
                          reservation.warehouseId &&
                          canReallocate && (

                          <div
                            style={{
                              marginTop:
                                "14px",
                            }}
                          >

                            {!isReallocationOpen ? (

                              <button
                                type="button"
                                onClick={() =>
                                  openReallocation(
                                    reservation,
                                  )
                                }
                                disabled={
                                  reallocationProcessing
                                }
                              >
                                <FontAwesomeIcon
                                  icon={
                                    faArrowRightArrowLeft
                                  }
                                />

                                {" "}
                                إعادة توزيع الحجز
                              </button>

                            ) : (

                              <div
                                className="admin-order-form"
                                style={{
                                  padding:
                                    "14px",

                                  border:
                                    "1px solid #cbd5e1",

                                  borderRadius:
                                    "12px",

                                  background:
                                    "#f8fafc",
                                }}
                              >

                                <strong>
                                  إعادة توزيع الحجز
                                </strong>


                                <label>
                                  المستودع الحالي
                                </label>

                                <input
                                  value={
                                    currentWarehouseName
                                  }
                                  disabled
                                />


                                <label>
                                  المستودع الهدف
                                </label>

                                <select
                                  value={
                                    targetWarehouseId
                                  }
                                  onChange={
                                    event =>
                                      setTargetWarehouseId(
                                        event.target.value,
                                      )
                                  }
                                  disabled={
                                    reallocationProcessing ||
                                    warehousesLoading
                                  }
                                >

                                  <option value="">
                                    اختر المستودع
                                  </option>

                                  {warehouses
                                    .filter(
                                      warehouse =>
                                        warehouse.id !==
                                          reservation.warehouseId &&
                                        warehouse.isActive,
                                    )
                                    .map(
                                      warehouse => (

                                        <option
                                          key={
                                            warehouse.id
                                          }
                                          value={
                                            warehouse.id
                                          }
                                        >
                                          {warehouse.nameAr ||
                                            warehouse.name}
                                          {" — "}
                                          {warehouse.code}
                                        </option>

                                      ),
                                    )}

                                </select>


                                {!canViewWarehouses && (

                                  <div className="admin-order-inline-warning">
                                    تحتاج صلاحية warehouses.view لعرض المستودعات الهدف.
                                  </div>

                                )}


                                <label>
                                  الكمية المراد نقلها
                                </label>

                                <input
                                  type="number"
                                  min={1}
                                  max={
                                    reservation.quantity
                                  }
                                  step={1}
                                  value={
                                    reallocationQuantity
                                  }
                                  onChange={
                                    event =>
                                      setReallocationQuantity(
                                        event.target.value,
                                      )
                                  }
                                  placeholder={`اتركها فارغة لنقل كامل الحجز (${reservation.quantity})`}
                                  disabled={
                                    reallocationProcessing
                                  }
                                />


                                <label>
                                  سبب إعادة التوزيع
                                </label>

                                <textarea
                                  rows={3}
                                  maxLength={
                                    500
                                  }
                                  value={
                                    reallocationReason
                                  }
                                  onChange={
                                    event =>
                                      setReallocationReason(
                                        event.target.value,
                                      )
                                  }
                                  placeholder="مثال: تجهيز الطلب من مستودع آخر"
                                  disabled={
                                    reallocationProcessing
                                  }
                                />


                                <div className="admin-order-inline-warning">
                                  طالما WAREHOUSE_INVENTORY_ENABLED=false سيقوم الـ Backend برفض إعادة التوزيع بأمان. تصبح العملية متاحة فعليًا بعد Migration والتفعيل.
                                </div>


                                <div
                                  style={{
                                    display:
                                      "flex",

                                    gap:
                                      "10px",

                                    flexWrap:
                                      "wrap",
                                  }}
                                >

                                  <button
                                    type="button"
                                    onClick={() =>
                                      reallocateReservation(
                                        reservation,
                                      )
                                    }
                                    disabled={
                                      reallocationProcessing ||
                                      !targetWarehouseId ||
                                      !reallocationReason.trim() ||
                                      !canViewWarehouses
                                    }
                                  >
                                    {reallocationProcessing
                                      ? "جاري النقل..."
                                      : "تنفيذ إعادة التوزيع"}
                                  </button>


                                  <button
                                    type="button"
                                    onClick={
                                      closeReallocation
                                    }
                                    disabled={
                                      reallocationProcessing
                                    }
                                  >
                                    إلغاء
                                  </button>

                                </div>

                              </div>

                            )}

                          </div>

                        )}

                      </div>

                    );
                  },
                )}

              </div>

            )}

          </>

        )}

      </section>


      {/* ===================================================
       * Status History
       * ================================================= */}

      <section className="admin-order-card">
        <div className="admin-order-card-title">
          <FontAwesomeIcon
            icon={
              faClockRotateLeft
            }
          />

          سجل حالات الطلب
        </div>

        {history.length ===
        0 ? (
          <div className="admin-orders-state small">
            لا يوجد سجل حالات.
          </div>
        ) : (
          <div className="admin-order-history">
            {history.map(
              (
                item,
                index,
              ) => (
                <div
                  key={
                    item.historyId ??
                    item.id ??
                    index
                  }
                >
                  <strong>
                    {String(
                      item.fromStatus ??
                        item.previousStatus ??
                        "—",
                    )}

                    {" → "}

                    {String(
                      item.toStatus ??
                        item.status ??
                        "—",
                    )}
                  </strong>

                  <span>
                    {item.reason ||
                      "بدون سبب"}
                  </span>

                  <small>
                    {item.changedByEmail ||
                      item.actorEmail ||
                      "النظام"}

                    {" • "}

                    {formatDate(
                      item.createdAt,
                    )}
                  </small>
                </div>
              ),
            )}
          </div>
        )}
      </section>

      {/* ===================================================
       * Timeline
       * ================================================= */}

      <section className="admin-order-card">
        <div className="admin-order-card-title">
          <FontAwesomeIcon
            icon={
              faTimeline
            }
          />

          Timeline الكامل
        </div>

        {timeline.length ===
        0 ? (
          <div className="admin-orders-state small">
            لا توجد أحداث.
          </div>
        ) : (
          <div className="admin-order-timeline">
            {timeline.map(
              (
                item,
                index,
              ) => (
                <div
                  key={
                    item.eventId ??
                    index
                  }
                >
                  <span className="admin-order-timeline-dot" />

                  <div>
                    <strong>
                      {item.type ||
                        "event"}
                    </strong>

                    <p>
                      {item.message ||
                        item.reason ||
                        ""}
                    </p>

                    <small>
                      {item.actorType ||
                        "system"}

                      {" • "}

                      {item.actorEmail ||
                        ""}

                      {" • "}

                      {formatDate(
                        item.createdAt,
                      )}
                    </small>
                  </div>
                </div>
              ),
            )}
          </div>
        )}
      </section>

    </div>
  );
};

export default AdminOrderDetails;